// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"256":"npm.chart.js-bf2cd571","416":"npm.chart.js-373d114a","825":"npm.xlsx"}[chunkId] || chunkId) + "-legacy." + {"59":"1bf1615f","256":"7dd949b7","260":"78469ea7","416":"df776731","583":"dae02be8","677":"685b5899","692":"38aef4b5","825":"85a51195","977":"9b07229e"}[chunkId] + ".js";
};